module.exports = __webpack_public_path__ + "img/smartMonitoringImg.99794727.png";